// extracted by mini-css-extract-plugin
export default {"container":"warning_container__07WCd","icon":"warning_icon__T5E2z"};